import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '@supabase/auth-helpers-react';
import { useUserTypes } from '../hooks/useUserTypes';

export default function PricingRedirectPage() {
  const navigate = useNavigate();
  const session = useSession();
  const { isParent, isCampOwner } = useUserTypes();

  useEffect(() => {
    // If user is logged in and is ONLY a parent (not a camp owner), redirect to parents pricing
    if (session?.user && isParent && !isCampOwner) {
      navigate('/pricing/parents', { replace: true });
    } else if (session?.user && isCampOwner) {
      // If user is a camp owner (with or without parent role), redirect to owners pricing
      navigate('/pricing/owners', { replace: true });
    } else {
      // Default to parents pricing for logged-out users
      navigate('/pricing/parents', { replace: true });
    }
  }, [session, isParent, isCampOwner, navigate]);

  // Show loading while redirecting
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </div>
    </div>
  );
}

